<template>
    <div class="deviceList">
        <div class="nav clearfix">
            <row>
                <van-col span="2">
                    <Icon name="arrow-left" size="26" @click="getBack" />
                </van-col>
                <van-col span="18" align="center" justify="center" style="font-size:19px;">入场检查</van-col>
                <van-col span="3" align="center">
                    <van-button plain type="primary" size="large"
                        style="font-size:15px;" @click="add">创&nbsp;建</van-button>
                </van-col>
            </row>
        </div>
        <div class="clientList">
            <row class="search">
                <van-col span="20"><search v-model="value" placeholder="请输入搜索关键词" class="search" /></van-col>
                <van-button type="primary" size="normal" round style="font-size:13px;margin-top:8px;">查&nbsp;询</van-button>
            </row>
            <row>
                <van-col span="2">全部</van-col>
                <van-col span="22">
                    <dropdown-menu active-color="#ee0a24">
                        <dropdown-item v-model="value1" :options="option1" />
                        <dropdown-item v-model="value2" :options="option2" />
                        <dropdown-item v-model="value3" :options="option3" />
                    </dropdown-menu>
                </van-col>

            </row>
            <List
                :finished="fansFinished"
                finished-text="已加载全部">
                <!-- v-model="fansLoading" -->
                <!-- @load="MoreList" -->
                <div
                    v-for="(item,index) in list"
                    :key="item.Id"
                    class="list clearfix">
                    <!-- @click="onClientDetails(item.TerminalId,item.SN)" -->
                    <div class="clearfix">
                        <row>
                            <van-col span="1">{{ index }}</van-col>
                            <van-col span="20">
                                <p>
                                    <span class="info-span">{{ item.SN }}</span>
                                    <span class="info-span">{{ item.TerminalId }}</span>
                                    <span class="info-span">{{ item.TotalHrm }}</span>
                                    <span class="info-span-red">{{ item.TotalHrm }}</span>
                                </p>
                                <p style="line-height:20px;"><icon name="clock-o" color="#1989fa" />入场：2020-03-05  15：00：32</p>
                            </van-col>
                            <van-col span="3"><van-button type="primary" round>派工</van-button></van-col>
                        </row>
                    </div>
                </div>
            </List>
            <p
                v-if="list.length === 0"
                class="noList">暂无数据</p>
        </div>
        <bottom />
    </div>
</template>

<script>

import { Icon, List, Button, Col, Row, Search, DropdownMenu, DropdownItem } from 'vant'
import bottom from '@/components/bottom'
export default {
    name: 'DeviceList',
    components: {
        bottom,
        Icon, List, [Button.name]: Button, [Col.name]: Col, Row, Search, DropdownMenu, DropdownItem
    },
    data() {
        return {
            fansLoading: false,
            fansFinished: false,
            parameter: {
                SnOrTerminalId: '',
                index: 0, // 当前页
                Size: 10, // 每页多少条
                Token: this.$store.state.token
            },
            list: [{
                'SN': null,
                'TerminalId': '6200290012',
                'TotalHrm': '0.000',
                'MsgArriveTime': '2020-04-23 19:05:54',
                'ServiceStart': null,
                'ServiceEnd': null,
                'Position': '河北省石家庄市桥西区;方兴汽车维修服务中心东33米;卓达上院西39米;河北威远集团有限公司高压开关厂西南73米;中国体育彩票东北84米',
                'BusinessName': null,
                'VehicleHmr': null,
                'MaintenanceCycle': null
            }, {
                'SN': null,
                'TerminalId': '6200290002',
                'TotalHrm': '0.000',
                'MsgArriveTime': '2020-04-09 16:08:15',
                'ServiceStart': null,
                'ServiceEnd': null,
                'Position': '河北省石家庄市桥西区;方兴汽车维修服务中心东南30米;卓达上院西53米;中国体育彩票东北68米;河北威远集团有限公司高压开关厂西南89米',
                'BusinessName': null,
                'VehicleHmr': null,
                'MaintenanceCycle': null
            }, {
                'SN': null,
                'TerminalId': '6200290004',
                'TotalHrm': '0.000',
                'MsgArriveTime': '2020-04-08 11:09:05',
                'ServiceStart': null,
                'ServiceEnd': null,
                'Position': '河北省石家庄市桥西区;方兴汽车维修服务中心东南31米;卓达上院西55米;中国体育彩票东北65米;河北威远集团有限公司高压开关厂西南92米',
                'BusinessName': null,
                'VehicleHmr': null,
                'MaintenanceCycle': null
            }, {
                'SN': null,
                'TerminalId': '6200290001',
                'TotalHrm': '0.000',
                'MsgArriveTime': '2020-03-31 11:02:56',
                'ServiceStart': '2020-04-01',
                'ServiceEnd': '2020-10-01',
                'Position': '湖南省株洲市株洲县;牛万冲西北465米;石门塘西南501米;横塘东南688米;山望冲东北1278米',
                'BusinessName': null,
                'VehicleHmr': null,
                'MaintenanceCycle': null
            }, {
                'SN': null,
                'TerminalId': '6200290005',
                'TotalHrm': '0.000',
                'MsgArriveTime': '2020-01-03 10:15:20',
                'ServiceStart': null,
                'ServiceEnd': null,
                'Position': '河北省石家庄市桥西区;方兴汽车维修服务中心东南38米;卓达上院西49米;中国体育彩票东北71米;河北威远集团有限公司高压开关厂西南90米',
                'BusinessName': null,
                'VehicleHmr': null,
                'MaintenanceCycle': null
            }],
            value: '',
            value1: 0,
            value2: 'a',
            value3: 'a',
            option1: [
                { text: '挖掘机', value: 0 },
                { text: '重卡', value: 1 },
                { text: '平地机', value: 2 }
            ],
            option2: [
                { text: '在场', value: 'a' },
                { text: '离场', value: 'b' }
            ],
            option3: [
                { text: '三一重工', value: 'a' },
                { text: '徐工', value: 'b' },
                { text: '柳工', value: 'c' }
            ]
        }
    },
    created() {
    },
    methods: {
    // 注销登录
        onLogout() {
            this.$router.push({
                path: '/information'
            })
            // Dialog.confirm({
            //   message: '确认退出吗？'
            // }).then(() => {
            //   this.$store.commit('logout')
            //   this.$router.push({
            //     path: '/information'
            //   })
            // })
        },
        getBack() {
            this.$router.back()
        },
        MoreList(num) {
            this.fansLoading = true
            if (num) {
                this.list = []
                this.parameter.index = 0
            }
            getDeviceList(this.parameter)
                .then((res) => {
                    if (res._Status == 1) {
                        this.parameter.index === 0 ? this.list = res._Data : this.list = this.list.concat(res._Data)
                        // 判读是否加载到最后一页
                        this.list.length >= res._Total ? this.fansFinished = true : this.parameter.index++
                        // 请求完毕后隐藏正在 加载样式
                        this.fansLoading = false
                    }
                })
        },
        // 新增
        add() {
            this.$router.push('/deviceSave')
        },
        onClientDetails(falg, sn) {
            this.$router.push({
                path: '/deviceDetails',
                query: {
                    id: falg,
                    sn: sn
                }
            })
        }
    }
}
</script>

<style lang='scss' scoped>
.deviceList{
  width: 100%;
  .logout{
    margin-top: -20px;
    color: blue;
  }
  .clientList{
    padding: 0px 40px;
    h2{
      font-size: 32px;
      font-weight: 700;
      margin-bottom: 25px;
    }
    .search{
      margin:10px 0;
      button{
        width: 100px;
        height: 50px;
        color: #ffffff;
        margin-left: 10px;
        border-radius: 10px;
      }
    }
    .list{
      padding: 20px 0;
      border-bottom: 1px solid #ccc;
      h3{
        font-size: 38px;
        font-weight: 700;
      }
      .msg{
        padding: 20px 0;
        font-size: 18px;
        .phone{
          margin-left: 10%;
          color: #3498db;
        }
      }
      p{
        color: #999;
        font-size: 20px;
        padding: 5px 0;
      }
    }
  }

}
.info-span{
    padding:0px 8px;
    color:#000;
}
.info-span-red{
    padding:0px 8px;
    color:#f00;
}
</style>
<style lang='scss' scoped>
.nav{
  width: 100%;
  padding: 20px 0px;
  background: #3498ff;
  color: #fff;
  .nav-title{
    width: 100%;
    font-size: 30px;
    text-align: center;
    display: block;
  }
}
.noList{
  text-align: center;
  margin-top: 50%;
  font-size: 26px;
  color: #ccc;
}
.van-dialog{
  width: 70%;
  height: 15%;
  .van-dialog__content{
    height: 65%;
    padding-top: 5%;
    text-align: center;
    .van-dialog__message{
      text-align: center;
      font-size: 26px;
    }
  }
  .van-dialog__footer--buttons{
    height: 35%;
    .van-button{
      width: 50%;
      height: 100%;
      .van-button__text{
        font-size: 26px;
      }
    }
  }
}
</style>
